$(document).ready(function() {
	
	var paySubs = 'input[name="field[nbr_b]"],input[name="field[nbr_k]"],input[name="field[nbr_t]"],' +
	                         'input[name="field[vademecum]"]';
	var selectorTypeAccount = 'input[name="field[soort_klant]"]';
	
	// some fields are shown only when the subscription requires payment
	if ($(paySubs).is(':checked')) {
		$('.gratisSubscription').hide();
	} else {
		$('.paymentSubscription').hide();
		$('.gratisSubscription').show();
	}
	
	// some fields are shown only when the account = zakelijk
	if ($(selectorTypeAccount).is(":checked")) {
		if ($('input[name="field[soort_klant]"]:checked').val() == 'z') {
			$('.zakelijkAccount').show();
		} else {
			$('.zakelijkAccount').hide();
			if ($('input[name="field[land]"]').val() != 'Nederland') {
				$('.zakelijkNotNetherlands').hide();
			}
		}
	} else {
		$('.zakelijkAccount').hide();
		$('.zakelijkNotNetherlands').hide();
	}
	
	
	$(paySubs).change(function () {
		if ($(this).is(":checked")) {
			$('.paymentSubscription').show();
			$('.gratisSubscription').hide();
		} else if ($(paySubs).filter(":checked").length == 0) {
			$('.paymentSubscription').hide();
			$('.gratisSubscription').show();
		}
	});
	
	$(selectorTypeAccount).change(function () {
		if ($(selectorTypeAccount).is(":checked")) {
			if ($(this).val() == 'z') {
				$('.zakelijkAccount').show();
				if ($('input[name="field[land]"]').val().toUpperCase() != 'NEDERLAND') {
					$('.zakelijkNotNetherlands').show();
				}
			} else {
				$('.zakelijkAccount').hide();
				$('.zakelijkNotNetherlands').hide();
			}
		}
	});
	
	$('input[name="field[land]"]').on('keyup change', function() {
		if ($('input[name="field[land]"]').val().toUpperCase() != 'NEDERLAND') {
			if ($(selectorTypeAccount).is(":checked")) {
				if ($('input[name="field[soort_klant]"]:checked').val() == 'z') {
					$('.zakelijkNotNetherlands').show();
				}
			}
		} else {
			$('.zakelijkNotNetherlands').hide();
		}
	});
	
});
